import { createTheme } from "thememirror";

/**
 * Custom dark theme for analytics code views (error logs, request modals, etc.)
 * Uses a dark blue background (#001531) for consistency across analytics UI
 */
export const analyticsCodeViewTheme = createTheme({
  variant: "dark",
  settings: {
    background: "#001531",
    foreground: "#e0e0e0",
    caret: "#ffffff",
    selection: "#003d82",
    lineHighlight: "#001531",
    gutterBackground: "#001531",
    gutterForeground: "#6b7280",
  },
  styles: [],
});
